<template>
  <div>
    <div id="chartTreeRow" class="contrainer-hieghtchar" style="display: none;">
      <div class="absolute-card none" v-if="chartLevelThreeStatus">
        <highchartsThree
          ref="highcharts"
          :options="chartLevelThree"
          :callback="callBackThree"
          :updateArgs="[true, true]"
        ></highchartsThree>
      </div>
      <div
        v-for="(user, index) in profilePositionThree"
        :key="user.id + index"
        :ref="setRefFromName(user.id)"
        class="profile-logo image image-profile-32 flex-mid"
        :style="`top: ${user.y}px; left: ${user.x}px;`"
        :class="[ blurMode ?  'blurelement': '' ]"
      >
        <div class="absolute-mid fs-10 center" style="width: 100px;">{{ user.id }}</div>
      </div>
    </div>
    <div id="chartTwoRow" class="contrainer-hieghtchar" style="display: none;">
      <div class="absolute-card none" v-if="chartLevelTwoStatus">
        <highchartsTwo
          ref="highcharts"
          :options="chartLevelTwo"
          :callback="callBackTwo"
          :updateArgs="[true, false]"
        ></highchartsTwo>
      </div>
      <div
        v-for="(user, index) in profilePositionTwo"
        :key="user.id + index"
        :ref="setRefFromName(user.id)"
        class="profile-logo image image-profile-32 flex-mid"
        :style="`top: ${user.y}px; left: ${user.x}px;`"
        :class="[ blurMode ?  'blurelement': '' ]"
      >
        <div class="absolute-mid fs-10 center" style="width: 100px;">{{ user.id }}</div>
      </div>
    </div>
    <div class="relative">
      <div style="position: absolute; left: 50%; transform: translate(-50%, 200px);">
        <div class="relative">
          <div class="absolute-mid" v-if="relationshipDataThree.length !== 0">
            <div class="overlay-3" :class="{ dark : themeMode == 'dark'}">
              <div class="outer-text text-network" :class="{ 'text-network-dark' : themeMode == 'dark'}">
                {{ $t('members.relationship_mapping.outer_network') }}
              </div>
            </div>
          </div>
          <div class="absolute-mid" v-if="relationshipDataTwo.length !== 0">
            <div class="inner-text text-network" :class="{ 'text-network-dark' : themeMode == 'dark'}">
                {{ $t('members.relationship_mapping.inner_network') }}
            </div>
            <div class="overlay-2" :class="{ dark : themeMode == 'dark'}"></div>
          </div>
          <div class="absolute-mid" v-if="relationshipDataOne.length !== 0">
            <div class="overlay-1" :class="{ dark : themeMode == 'dark'}"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="contrainer-hieghtchar" :class="{ none: relationshipStatus}">
      <div class="absolute-card none" v-if="chartLevelOneStatus">
        <highchartsOne
          ref="highcharts"
          :options="chartLevelOne"
          :callback="callBack"
          :updateArgs="[true, false]"
        ></highchartsOne>
      </div>
      <div
        v-for="(user, index) in profilePosition"
        :key="index"
        class="profile-logo image image-profile-32 flex-mid"
        :style="`top: ${user.y}px; left: ${user.x}px;`"
        :class="[ blurMode ?  'blurelement': '' ]"
      >
        <img
          v-if="user.pic"
          v-lazy="user.pic"
          :alt="user.firstname + ' ' + user.lastname"
          class="absolute-mid"
          :class="[`${checkeDarkTheme? 'image-skeleton-dark':'image-skeleton'} image-border-${borderColorOfNode(user.house_color)} ${index === 0 ? 'image-profile-44 main-node' : 'image-profile-32'}`]"
        />
        <div
          v-else
          class="absolute-mid"
          :class="[`${checkeDarkTheme? 'image-dark':'image'} image-border-${borderColorOfNode(user.house_color)} ${index === 0 ? 'image-profile-44 main-node' : 'image-profile-32 '}`]"
        >
          <div
            class="flex-mid text-in-image"
            :class="[`${index === 0 ? 'text-in-image-44' : 'text-in-image-32'}`]"
          >{{ $utils('acronymName', {firstName: user.firstname, lastName: user.lastname}) }}</div>
        </div>
        <div
          v-if="index != 0"
          :class="`text-profile ${ themeMode === 'dark'? 'text-profile-dark': 'text-profile-light'} absolute-mid center`"
        >{{ user.teamName === profileCenter ? '' : user.teamName }}</div>
      </div>
      <svg height="400" width="450">
        <line
          v-for="(user, index) in linePosition"
          :key="user.from + user.to + '-' + index"
          :x1="user.fromPlotX + 16"
          :y1="user.fromPlotY + 16"
          :x2="user.toPlotX + 16"
          :y2="user.toPlotY + 16"
          :stroke="relWeightOpacity(user.rel_weight)"
          stroke-dasharray="3 3"
          stroke-width="1"
        />
      </svg>
    </div>
    <div :class="[`relative ${!relationshipStatus? 'none':''} ${this.$router.currentRoute.path ==='/relationship-mapping'? 'padding-80': ''}`]">
      <img
        alt="padding relationship data."
        v-lazy="imageEmpty"
        class="flex-mid m-auto"
      />
      <div class="absolute-mid middle-padding">
        <img
          v-if="centerProfile.pic"
          v-lazy="centerProfile.pic"
          class="absolute-mid image-skeleton image-profile-44 main-node"
          :class="[`${checkeDarkTheme? 'image-skeleton-dark':'image-skeleton'} image-border-${borderColorOfNode(centerProfile.house_color)}`]"
        />
        <div
          v-else
          class="absolute-mid image-profile-44 main-node"
          :class="[`${checkeDarkTheme? 'image-dark':'image'} image-border-${borderColorOfNode(centerProfile.house_color)}`]"
        >
          <div
            class="flex-mid text-in-image text-in-image-44"
          >{{ $utils('acronymName', {firstName: centerProfile.firstname, lastName: centerProfile.lastname}) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Highcharts, { chart } from "highcharts";
import highchartsMore from "highcharts/highcharts-more";
import highchartsNetworkgraph from "highcharts/modules/networkgraph";
import stockInit from "highcharts/modules/stock";
const newPositionsRelationship = require("./relationship-position");

highchartsMore(Highcharts);
highchartsNetworkgraph(Highcharts);
import { Chart } from "highcharts-vue";
export default {
  name: "relationshipsMapping",
  props: ["modalMemberData", "profile"],
  data: function() {
    return {
      target: undefined
    };
  },
  components: {
    highchartsOne: Chart,
    highchartsTwo: Chart,
    highchartsThree: Chart
  },
  data() {
    return {
      mockDegRelationsMappingList: [],
      linePosition: [],
      chartLevelOne: {
        chart: {
          type: "networkgraph"
        },
        title: {
          text: ""
        },
        plotOptions: {
          networkgraph: {
            link: {
              width: 5
            },
            layoutAlgorithm: {
              // === linkLength: distance ===
              linkLength: 1,
              integration: "euler",
              // approximation: "barnes-hut",
              enableSimulation: false
            }
          }
        },
        series: [
          {
            marker: {
              id: "language-tree",
              mass: 1,
              radius: 10
            },
            dataLabels: {
              enabled: false,
              textPath: {
                enabled: false
              },
              linkFormat: "",
              allowOverlap: true
            },
            data: []
          }
        ]
      },
      chartLevelTwo: {
        chart: {
          type: "networkgraph"
        },
        title: {
          text: ""
        },
        plotOptions: {
          networkgraph: {
            link: {
              width: 5
            },
            layoutAlgorithm: {
              linkLength: 25,
              integration: "euler",
              // approximation: "barnes-hut",
              enableSimulation: false
            }
          }
        },
        series: [
          {
            marker: {
              id: "language-tree",
              mass: 1,
              radius: 10
            },
            dataLabels: {
              enabled: true,
              textPath: {
                enabled: false
              },
              linkFormat: "",
              allowOverlap: true
            },
            data: []
          }
        ]
      },
      chartLevelThree: {
        chart: {
          type: "networkgraph"
        },
        title: {
          text: ""
        },
        plotOptions: {
          networkgraph: {
            link: {
              width: 5
            },
            layoutAlgorithm: {
              linkLength: 45,
              integration: "euler",
              // approximation: "barnes-hut",
              enableSimulation: false
            }
          }
        },
        series: [
          {
            marker: {
              id: "language-tree",
              mass: 1,
              radius: 5
            },
            dataLabels: {
              enabled: false,
              textPath: {
                enabled: false
              },
              linkFormat: "",
              allowOverlap: true
            },
            data: []
          }
        ]
      },
      chartLevelOneStatus: false,
      chartLevelTwoStatus: false,
      chartLevelThreeStatus: false,
      relationshipDataOne: [],
      relationshipDataTwo: [],
      relationshipDataThree: [],
      distanceFromCenterOne: 20,
      distanceFromCenterTwo: 51,
      distanceFromCenterThree: 81,
      profilePosition: [],
      profilePositionOne: [],
      profilePositionTwo: [],
      profilePositionThree: [],
      profileCenter: null,
      movingPositions: newPositionsRelationship,
      callBackTime: 0,
      centerProfile: {
        firstname: "",
        lastname: "",
        pic: ""
      },
      rowDistMap: [],
      mappingData: {},
      themeMode: 'light'
    };
  },
  computed: {
    webviewData() {
      return this.$store.getters["newmember/webviewData"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    relationshipStatus () {
      let dataLength = Object.keys(this.profilePosition).length;
      if (dataLength < 1) {
        return true;
      }
      return false;
    },
    imageEmpty () {
      switch (this.themeMode) {
        case "light":
          return require("@/assets/images/components/relationships/placeholder_relationshipmap.png");
        case "dark":
          return require("@/assets/images/components/relationships/placeholder_dark_relationshipmap.png");
        default:
          return require("@/assets/images/components/relationships/placeholder_relationshipmap.png");
      }
    },
    checkeDarkTheme() {
      switch (this.themeMode) {
        case "light":
          return false;
        case "dark":
          return true;
        default:
          return false;
      }
    }
  },
  watch: {
    modalMemberData() {
      if (this.modalMemberData && this.modalMemberData.relationships) {
        this.centerProfile.house_color = this.modalMemberData.relationships.house_color || "cccccc";
        this.centerProfile.pic = this.modalMemberData.relationships.pic || "";
        this.centerProfile.firstname = this.modalMemberData.relationships.firstname;
        this.centerProfile.lastname = this.modalMemberData.relationships.lastname;
        if (this.modalMemberData.relationships.dist_map.length !== 0) {
          this.mappingData = this.modalMemberData.relationships;
        }
      }
    },
    mappingData() {
      if (this.mappingData) {
        this.detectLabel(this.mappingData);
        this.setDataToChart();
      }
    },
    webviewData() {
      let data = this.webviewData['relationships'];
      if (data.dist_map.length === 0) {
        this.centerProfile.firstname = data.firstname;
        this.centerProfile.lastname = data.lastname;
        this.centerProfile.pic = data.pic;
        this.centerProfile.house_color = data.house_color || "cccccc";
      } else if (data) {
        this.centerProfile = data;
        this.mappingData = data;
      }
    },
  },
  mounted () {
    if (this.$router.currentRoute.path === "/relationship-mapping" && this.$router.currentRoute.query.code) {
      this.$store.dispatch("newmember/getRelationshipMobile", {code:this.$router.currentRoute.query.code});
    }

    if (this.$router.currentRoute.path === "/relationship-mapping" && this.$router.currentRoute.query.mode === 'dark') {
      this.themeMode = 'dark'
      document.querySelector('body').style.backgroundColor = "#242424"
    }
  },
  methods: {
    setRefFromName(name) {
      let refName = name.split(" ");
      return refName.join("");
    },
    detectLabel(data) {
      this.profileCenter = data.center;
      let relationship = data.dist_map.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
      this.rowDistMap = data.dist_map;
      relationship.forEach(dist_map => {
        if (dist_map.distance === 1) {
          this.relationshipDataOne.push({
            from: this.profileCenter,
            to: dist_map.email
          });
        } else if (dist_map.distance === 2) {
          this.relationshipDataTwo.push({
            from: this.profileCenter,
            to: dist_map.email
          });
        } else if (dist_map.distance === 3) {
          this.relationshipDataThree.push({
            from: this.profileCenter,
            to: dist_map.email
          });
        }
      });
    },
    async setDataToChart() {
      await this.levelOne();
      await this.levelTwo();
      await this.levelThree();
    },
    levelOne() {
      let setData = new Promise(resolve => {
        let newRelationship = this.relationshipDataOne;
        let dataLength = Object.keys(newRelationship).length;
        this.distanceFromCenterOne =
          this.distanceFromCenterOne - (dataLength - dataLength / 2);
        if (dataLength > 11) {
          this.distanceFromCenterOne = this.distanceFromCenterOne + ((dataLength - 11) * 1.25);
        }
        this.distanceFromCenterOne = this.distanceFromCenterOne.toFixed(1);
        let newLinkLength = this.distanceFromCenterOne;
        this.chartLevelOne.series[0].data = newRelationship;
        this.chartLevelOne.plotOptions.networkgraph.layoutAlgorithm.linkLength = newLinkLength;
        resolve(true);
      });
      setData.then(value => {
        setTimeout(() => {
          this.chartLevelOneStatus = value;
        }, 200);
      });
    },
    levelTwo() {
      let setData = new Promise(resolve => {
        let newRelationship = this.relationshipDataTwo;
        let dataLength = Object.keys(newRelationship).length;
        this.distanceFromCenterTwo =
          this.distanceFromCenterTwo - this.distanceFromCenterOne / 3;
        if (dataLength > 8) {
          this.distanceFromCenterTwo = this.distanceFromCenterTwo - (dataLength - 8) * 4;
          if (this.distanceFromCenterTwo < 18) {
            this.distanceFromCenterTwo = 18;
          }
        } else if (dataLength > 6) {
          this.distanceFromCenterTwo =
            this.distanceFromCenterTwo - (dataLength - 8) * 3;
        } else {
          this.distanceFromCenterTwo =
            this.distanceFromCenterTwo - dataLength * 2.5;
        }
        this.distanceFromCenterTwo = Number(this.distanceFromCenterTwo.toFixed(1));
        let newLinkLength = this.distanceFromCenterTwo;
        if (newLinkLength > 26 && dataLength > 7) {
          newLinkLength = 26;
        } else if (newLinkLength > 28 && dataLength > 5) {
          newLinkLength = 28;
        }
        this.chartLevelTwo.series[0].data = newRelationship;
        this.chartLevelTwo.plotOptions.networkgraph.layoutAlgorithm.linkLength = newLinkLength;
        resolve(true);
      });
      setData.then(value => {
        setTimeout(() => {
          this.chartLevelTwoStatus = value;
        }, 200);
      });
    },
    levelThree() {
      let setData = new Promise(resolve => {
        let newRelationship = this.relationshipDataThree;
        let dataLength = Object.keys(newRelationship).length;
        this.distanceFromCenterThree = this.distanceFromCenterThree + this.distanceFromCenterTwo / 10;
        if (dataLength > 8) {
          this.distanceFromCenterThree = 45 - (dataLength - 8) * 1;
          if (this.distanceFromCenterThree < 46) {
            this.distanceFromCenterThree = 46;
          }
        } else if (dataLength > 6) {
          this.distanceFromCenterThree =
            this.distanceFromCenterThree - (6 * 5 + (dataLength - 6) * 2);
        } else if (dataLength > 1) {
          this.distanceFromCenterThree =
            this.distanceFromCenterThree - (dataLength * 6 - (dataLength / 2));
        } else {
          this.distanceFromCenterThree =
            this.distanceFromCenterThree - 2;
        }
        this.distanceFromCenterThree = this.distanceFromCenterThree.toFixed(1);
        let newLinkLength = this.distanceFromCenterThree;
        this.chartLevelThree.series[0].data = newRelationship;
        this.chartLevelThree.plotOptions.networkgraph.layoutAlgorithm.linkLength = newLinkLength;
        resolve(true);
      });
      setData.then(value => {
        setTimeout(() => {
          this.chartLevelThreeStatus = value;
        }, 200);
      });
    },
    async callBack(value) {
      let chart = value.series.pop();
      let movingValue = await this.getPositionOfProfile(chart.nodes, "one");
      await this.addAnotherRelationship();
    },
    async callBackTwo(value) {
      let chart = value.series.pop();
      let movingValue = await this.getPositionOfProfile(chart.nodes, "two");
      await this.addAnotherRelationship();
    },
    async callBackThree(value) {
      let chart = value.series.pop();
      let movingValue = await this.getPositionOfProfile(chart.nodes, "three");
      await this.addAnotherRelationship();
    },
    async getPositionOfProfile(profile, chartDistacne) {
      let movingToCenter = {
        plotX: 0,
        plotY: 0
      };
      let AddedProfileCenter = true;
      _.forEach(await profile, (value, index) => {
        if (value.id === this.profileCenter) {
          movingToCenter.plotX = 225 - value.plotX.toFixed(0) - 16;
          movingToCenter.plotY = 200 - value.plotY.toFixed(0) - 16;
        }
        this.rowDistMap.forEach((dist_map) => {
          if (dist_map.email === value.id) {
            this.profilePosition.push({
              x: (value.plotX + movingToCenter.plotX).toFixed(0),
              y: (value.plotY + movingToCenter.plotY).toFixed(0),
              id: value.id,
              pic: dist_map.pic || "",
              house_color: dist_map.house_color || "cccccc",
              firstname: dist_map.firstname,
              lastname: dist_map.lastname,
              teamName: dist_map.name
            });
          } else if (this.profileCenter === value.id && AddedProfileCenter) {
            AddedProfileCenter = false;
            let getColor = this.centerProfile.house_color;
            this.profilePosition.push({
              x: (value.plotX + movingToCenter.plotX).toFixed(0),
              y: (value.plotY + movingToCenter.plotY).toFixed(0),
              id: value.id,
              pic: this.centerProfile.pic || "",
              house_color: getColor,
              firstname: this.centerProfile.firstname,
              lastname: this.centerProfile.lastname,
              teamName: ''
            });
          }
        })
        if (chartDistacne === "one") {
          this.profilePositionOne.push({
            x: (value.plotX + movingToCenter.plotX).toFixed(0),
            y: (value.plotY + movingToCenter.plotY).toFixed(0),
            id: value.id
          });
        } else if (chartDistacne === "two") {
          this.profilePositionTwo.push({
            x: (value.plotX + movingToCenter.plotX).toFixed(0),
            y: (value.plotY + movingToCenter.plotY).toFixed(0),
            id: value.id
          });
        } else if (chartDistacne === "three") {
          this.profilePositionThree.push({
            x: (value.plotX + movingToCenter.plotX).toFixed(0),
            y: (value.plotY + movingToCenter.plotY).toFixed(0),
            id: value.id
          });
        }
      });
      return movingToCenter;
    },
    addAnotherRelationship() {
      ++this.callBackTime;
      let statusLoop = false;
      let relationship = this.mappingData.node_relations;
      if (this.callBackTime > 2) {
        statusLoop = true;
        let dataLengthOne = Object.keys(this.profilePositionOne).length;
        let dataLengthTwo = Object.keys(this.profilePositionTwo).length;
        let dataLengthThree = Object.keys(this.profilePositionThree).length;
        if (dataLengthOne < 11) {
          let changeOneAndTwoStatus = dataLengthOne === dataLengthTwo;
          let changeTwoAndThreeStatus = dataLengthTwo === dataLengthThree;
          let changeOneAndThreeStatus = dataLengthOne === dataLengthThree
          if (changeOneAndTwoStatus || changeTwoAndThreeStatus) {
            this.profilePositionTwo.forEach((user, index) => {
              this.profilePosition.forEach((realUser) => {
                if (user.id === realUser.id && index > 0 && this.movingPositions.movingPositions[dataLengthTwo - 1] && this.movingPositions.movingPositions[dataLengthTwo - 1][2]) {
                  realUser.x = this.movingPositions.movingPositions[dataLengthTwo - 1][2][index - 1].plotX;
                  realUser.y = this.movingPositions.movingPositions[dataLengthTwo - 1][2][index - 1].plotY;
                }
              });
            });
          }
          if (changeTwoAndThreeStatus || changeOneAndThreeStatus) {
            this.profilePositionThree.forEach((user, index) => {
              this.profilePosition.forEach((realUser) => {
                if (user.id === realUser.id && index > 0 && this.movingPositions.movingPositions[dataLengthThree - 1] && this.movingPositions.movingPositions[dataLengthThree - 1][3]) {
                  realUser.x = this.movingPositions.movingPositions[dataLengthThree - 1][3][index - 1].plotX;
                  realUser.y = this.movingPositions.movingPositions[dataLengthThree - 1][3][index - 1].plotY;
                }
              });
            });
          }
          if (changeOneAndTwoStatus && dataLengthOne < 10) {
            this.profilePositionOne.forEach((user, index) => {
              this.profilePosition.forEach((realUser) => {
                if (user.id === realUser.id && index > 0) {
                  realUser.x = this.movingPositions.movingPositions[dataLengthOne - 1][1][index - 1].plotX;
                  realUser.y = this.movingPositions.movingPositions[dataLengthOne - 1][1][index - 1].plotY;
                }
              });
            });
          }
        }
        relationship.forEach(line => {
          this.relWeightOpacity(line.rel_weight);
          this.profilePosition.forEach(user => {
            if (user.id === line.node1) {
              line.fromPlotX = Number(user.x);
              line.fromPlotY = Number(user.y);
            } else if (user.id === line.node2) {
              line.toPlotX = Number(user.x);
              line.toPlotY = Number(user.y);
            }
          });
        });
      }

      if (statusLoop) {
        this.linePosition = this.linePosition.concat(relationship);
      }
    },
    borderColorOfNode(code) {
      if (!code || code === "") {
        return "cccccc";
      } else {
        return code.split("#").join("");
      }
    },
    relWeightOpacity(nubmer) {
      let opacity = nubmer.toFixed(1);
      if (opacity < .1) {
        opacity = .1;
      };
      switch (this.themeMode) {
        case "light":
          return `rgba(0, 0, 0, ${opacity})`;
        case "dark":
          return `rgba(255, 255, 255, ${opacity})`;
        default:
          return `rgba(0, 0, 0, ${opacity})`;
      }
    },
    getHouseColor (id) {
      if (id === "-LWPrZbcyHAVHIFUsWLd") {
        return "ea183c" // corvus
      } else if (id === "-LWPrOElCYViBd6j6qP-") {
        return "ffbf1f" // leonos
      } else if (id === "-LWOr-XsbZM2digYl1QL") {
        return "1d97f2" // delphinus
      } else {
        return "cccccc"
      }
    },
  },
  beforeDestroy: function(){
    let resetData = [];
    this.chartLevelTwo.series[0].data = resetData;
  }
};
</script>

<style lang="scss" scoped>
.profile-logo {
  position: absolute;
  font-family: 'Lato', 'Kanit', Arial, sans-serif;
  > .text-profile {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    font-size: 10px;
    top: 40px;
    width: 120px;
    font-weight: 700;
  }
  > .text-profile-light {
    color: #9b9b9b;
    text-shadow: 1px -1px 0px white, -1px 1px 0px white, 1px 1px 0px white,
      -1px -1px 0px white;
  }
  > .text-profile-dark {
    color: #c7c7c7;
    text-shadow: 1px -1px 0px black, -1px 1px 0px black, 1px 1px 0px black,
      -1px -1px 0px black;
  }
}
.absolute-card {
  position: absolute;
  width: 450px;
  height: 400px;
}
.main-node {
  z-index: 100;
}
.contrainer-hieghtchar {
  width: 450px;
  height: 400px;
  position: relative;
}
.padding-80 {
  padding-top: 80px;
  > .middle-padding {
  top: calc(50% + 40px);
  }
}
.overlay-1, .overlay-2, .overlay-3 {
  // border: 1px dashed #f7ff2ca2;
  background-color: #0000000a;
  position: relative;
}
.text-network {
  position: absolute;
  color: #32C2D5;
  font-size: 12px;
  font-weight: 700;
  font-family: 'Lato', 'Kanit', Arial, sans-serif;
}
.text-network-dark {
  color: #f7ff2c;
}
.outer-text {
  bottom: -20px;
  left: 50%;
  transform: translate(-50%, 0);
}
.inner-text {
  bottom: 20px;
  left: 50%;
  transform: translate(-50%, 0);
}
.overlay-1 {
  width: 130px;
  height: 130px;
  border-radius: 130px;
}
.overlay-2 {
  width: 245px;
  height: 245px;
  border-radius: 245px;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='200' ry='200' stroke='%2332C2D5' stroke-width='1' stroke-dasharray='4%2c 5' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
}
.overlay-3 {
  width: 350px;
  height: 350px;
  border-radius: 350px;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='400' ry='400' stroke='%2332C2D5' stroke-width='1' stroke-dasharray='4%2c 5' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
}
.dark.overlay-2, .dark.overlay-3 {
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='400' ry='400' stroke='yellow' stroke-width='1' stroke-dasharray='4%2c 5' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
  background-color: #ffffff0a;
}
</style>
